import React from 'react';
// import get from 'lodash/get';
import DEV from '@lskjs/dev/DEV';

export default props => (
  <DEV json={props} />
);

// field,
// form,
// value={field.value}
//
